import { IconProps } from '@components/atoms/Icons/Icons.type.ts'

export function EyeCloseIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_617_7380)">
        <path
          d="M11.8002 17.8001C7.48023 17.8001 3.63023 14.1501 2.17023 12.5701C2.06023 12.4601 2.00023 12.3101 2.00023 12.1501C2.00023 11.9901 2.06023 11.8401 2.17023 11.7201C2.75023 11.0901 3.38023 10.4901 4.04023 9.94006C4.46023 9.59006 4.52023 8.95006 4.16023 8.53006C3.81023 8.11006 3.18023 8.05006 2.75023 8.41006C2.03023 9.01006 1.34023 9.67006 0.710234 10.3501C0.250234 10.8401 -0.00976562 11.4701 -0.00976562 12.1401C-0.00976562 12.8101 0.240234 13.4501 0.700234 13.9301C2.73023 16.1201 6.86023 19.7901 11.7902 19.7901C12.3402 19.7901 12.7902 19.3401 12.7902 18.7901C12.7902 18.2401 12.3402 17.7901 11.7902 17.7901L11.8002 17.8001Z"
          fill="currentColor"
        />
        <path
          d="M18.4302 17.4201C19.1802 17.0201 20.1302 16.4701 20.8202 15.9301C21.6802 15.2501 22.2402 14.6501 22.8802 13.9501C23.3402 13.4601 23.6002 12.8301 23.6002 12.1601C23.6002 11.4901 23.3502 10.8501 22.9202 10.4101C20.7502 7.84006 17.2102 4.45006 11.7702 4.61006C10.0802 4.66006 7.89023 5.42006 6.83023 5.82006L2.31023 1.29006C1.92023 0.900059 1.28023 0.900059 0.890234 1.29006C0.500234 1.68006 0.500234 2.31006 0.890234 2.70006L21.2902 23.1101C21.4902 23.3101 21.7402 23.4001 22.0002 23.4001C22.2602 23.4001 22.5102 23.3001 22.7102 23.1101C23.1002 22.7201 23.1002 22.0901 22.7102 21.7001L18.4302 17.4301V17.4201ZM11.8302 6.60006C15.3602 6.49006 18.3302 8.06006 21.4302 11.7401C21.5402 11.8501 21.6002 12.0001 21.6002 12.1601C21.6002 12.3201 21.5402 12.4601 21.4302 12.5801C21.4302 12.5801 21.3602 12.6601 21.3502 12.6601C20.7702 13.2901 20.3102 13.7801 19.5702 14.3601C18.8202 14.9501 17.6302 15.5901 16.9402 15.9401L8.39023 7.38006C9.41023 7.03006 10.7802 6.63006 11.8302 6.60006Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_617_7380">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
